













































import { Component, Vue } from "vue-property-decorator";
import { MusicLinkModel, SongModel } from "../models/Song";
import { MusicPlatformModel } from "../models/MusicPlatform";
import { apiConfigService } from "../config/api.config";
import { GlobalEvent, responseHandler } from "../shared/helpers";
import { FormEvents } from "../constants";
import { songsService } from "../api/songs.api";

@Component
export default class SongForm extends Vue {
  payload: any = {
    musicLinks: []
  };

  snippet!: File;

  genres: any[] = [];

  get isUpdate() {
    return this.payload.id ? true : false;
  }

  async save(payload: SongModel) {
    try {
      // this.showLoading();
      this.isLoading = true;
      const formData = new FormData();

      formData.append("snippet", this.snippet);
      formData.append("title", payload.title);
      formData.append("genreId", payload.genreId);

      formData.append("musicLinks", JSON.stringify(payload.musicLinks));

      const response = !this.isUpdate
        ? await songsService.create(formData)
        : await songsService.update(this.payload.id, formData);
      this.toastSuccess(response.message);
      this.modal("song-form", false);
      // this.hideLoading();
      this.isLoading = false;
      this.payload = {
        musicLinks: []
      };
      const snipptRef: any = this.$refs.snippet;
      snipptRef.value = null;
      this.$emit("refresh");
    } catch (error) {
      this.handleError(error);
    }
  }

  mounted() {
    GlobalEvent.$on(FormEvents.SH_SONG_FORM, (data: SongModel) => {
      this.payload = data;
      this.modal("song-form", true);
      this.handleModalOpen();
    });
  }

  handleModalOpen() {
    this.handleGenres();
    this.handleMusicPlatforms();
  }

  async handleMusicPlatforms() {
    try {
      this.isLoading = true;
      const response = await apiConfigService.request().get("music-platforms");
      const output = responseHandler(response);

      const musicPlatforms = output.data as MusicPlatformModel[];

      const musicLinks = this.isUpdate
        ? this.payload.musicLinks.map((x: MusicLinkModel) => {
            return {
              musicPlatformId: x.musicPlatformId,
              name: x.slug,
              link: x.link
            };
          })
        : musicPlatforms.map(x => {
            return {
              musicPlatformId: x.id,
              name: x.name,
              link: null
            };
          });

      this.payload = {
        ...this.payload,
        musicLinks
      };

      this.isLoading = false;
    } catch (error) {
      this.handleError(error);
    }
  }

  async handleGenres() {
    try {
      const response = await apiConfigService.request().get("genres/list/get");
      const output = responseHandler(response);
      this.genres = output.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  uploadFile(file: File) {
    this.snippet = file;
  }
}
